"use client"

import { useMemo } from "react"
import { Button } from "../../../components/ui/button"
import { useNavigate } from "react-router-dom"
import placeholder from "../../../util/placeholder"
import { fetcher } from "../../../util/axiosConfig"
import useSWR from "swr"

export default function TruckCategories() {
  const navigate = useNavigate()

  const {data, isLoading, error, mutate} = useSWR("newAdmin/truck-category-all", fetcher)

  const categories: TruckCategory[] = useMemo(() => {
    return data?.truckCategories ?? []
  } , [data])

  const handleCreateClick = () => {
    navigate("/admin/trucks/create")
  }

  return (
    <div className="min-h-screen bg-gray-50">

      <div>
        {/* Main content */}
        <main className="flex-1 p-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex justify-between items-center mb-8">
              <h1 className="text-2xl font-medium text-primary">Vehicle Categories</h1>
              <Button className="bg-blue-600 hover:bg-blue-700 text-white px-8" onClick={handleCreateClick}>
                Create
              </Button>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : error ? (
              <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-md">
                {error}
                {/* <Button variant="outline" className="mt-2" onClick={fetchCategories}>
                  Retry
                </Button> */}
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {categories.map((category) => (
                  <div key={category.id} className="bg-white rounded-lg shadow-sm border overflow-hidden">
                    <div className="h-48 bg-gray-100 flex items-center justify-center">
                      {category.image ? (
                        <img
                          src={category.image.includes("example") ? placeholder : category.image}
                          alt={category.name}
                          className="w-full h-full object-contain p-4"
                        />
                      ) : (
                        <div className="text-gray-400">No image</div>
                      )}
                    </div>
                    <div className="p-4">
                      <div className="flex justify-between items-start mb-2">
                        <div className="  py-1 rounded-md text-sm font-medium">
                          {category.vehiclesCount} Vehicles Listed
                        </div>
                        <Button onClick={() => navigate(`/admin/trucks/${category.id}`, { state: category })} variant="outline" className=" bg-primary-accent border-primary text-primary hover:bg-primary hover:text-white">
                          Manage
                        </Button>
                      </div>
                      <div className="font-semibold text-lg opacity-20">{category.name} {category.code}</div>
                      
                    </div>
                  </div>
                ))}

                {/* If no categories are found */}
                {categories.length === 0 && (
                  <div className="col-span-3 bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
                    <p className="text-gray-500 mb-4">No vehicle categories found</p>
                    <Button onClick={handleCreateClick}>Create Your First Category</Button>
                  </div>
                )}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  )
}

